import { quizClosedTranslations } from './409/quizClosed.translation.fr.ts';
import { quizExpiredTranslations } from './409/quizExpired.translation.fr.ts';
import { quizFinishedTranslations } from './409/quizFinished.translation.fr.ts';
import { quizToManyRevisitsTranslations } from './409/quizToManyRevisits.translation.fr.ts';
import { personalDataTranslations } from './personalData/personalData.translation.fr.ts';
import type { ProcessViewTranslation } from './processView.translations.pl.ts';
import { quizQuestionsTranslations } from './quizQuestions/quizQuestions.translation.fr.ts';
import { quizScenariosTranslations } from './quizScenarios/quizScenarios.translation.fr.ts';

export const processViewTranslations: ProcessViewTranslation = {
  quizQuestions: quizQuestionsTranslations,
  409: {
    ['409_1']: quizFinishedTranslations,
    ['409_2']: quizExpiredTranslations,
    ['409_3']: quizToManyRevisitsTranslations,
    ['409_closed']: quizClosedTranslations,
  },
  quizScenarios: quizScenariosTranslations,
  personalData: personalDataTranslations,
};
